import { createSlice } from "@reduxjs/toolkit";
import FILTERS_KEYS from "@utils/filters_keys.js";
import { REHYDRATE } from "redux-persist/es/constants";
import { mergeFilters, toggleReduxSliceFiltersVisibility } from "../../../helpers/reduxHelpers.js";

const defaultFilters = [
	{ id: FILTERS_KEYS.users.roles, name: "users:rolesFilter", visible: false },
	{ id: FILTERS_KEYS.users.status, name: "users:statusFilter", visible: false },
	{ id: FILTERS_KEYS.users.businessUnits, name: "users:businessUnitFilter", visible: false },
	{ id: FILTERS_KEYS.users.clients, name: "users:clientsFilter", visible: false },
	{ id: FILTERS_KEYS.users.distributors, name: "users:distributorsFilter", visible: false },
];
const initialState = {
	data: [],
	selectedUser: null,
	page: 1,
	perPage: 10,
	totalItems: 0,
	totalPage: 0,
	loading: false,
	filters: [...defaultFilters],
};

const usersSlice = createSlice({
	name: "auth/user",
	initialState,
	reducers: {
		setUsersData: (state, action) => {
			const { data, totalItems, page, perPage } = action.payload;

			state.data = data || [];
			state.totalItems = totalItems || 0;
			state.page = page || 1;
			state.perPage = perPage || 10;
			state.totalPage = Math.ceil(totalItems / perPage);
		},
		setLoadingUsers: (state, action) => {
			state.loading = action.payload;
		},
		setSelectedUser: (state, action) => {
			state.selectedUser = action.payload;
		},
		setDeleteUser: (state, action) => {
			state.data = state.data.filter((unit) => unit.id !== action.payload);
		},
		setAddUser: (state, action) => {
			state.data.push(action.payload);
			state.totalItems += 1;
			state.totalPage = Math.ceil(state.totalItems / state.perPage);
		},
		setEditUser: (state, action) => {
			const { id, updatedData } = action.payload;
			state.data = state.data.map((unit) => (unit.id === id ? { ...unit, ...updatedData } : unit));
		},
		toggleUsersFiltersVisibility: toggleReduxSliceFiltersVisibility,
	},
	extraReducers: (builder) => {
		builder.addCase(REHYDRATE, (state, action) => {
			// Get persisted filters
			const persistedFilters =
				action.payload?.modules?.accountManagement.userState?.filters ?? null;
			// Merge filters with persisted state
			state.filters = mergeFilters(persistedFilters, defaultFilters);
		});
	},
});

export const {
	setUsersData,
	setLoadingUsers,
	setSelectedUser,
	setDeleteUser,
	setAddUser,
	setEditUser,
	toggleUsersFiltersVisibility,
} = usersSlice.actions;

export default usersSlice.reducer;
